import type { LiquidTotalInsight } from "@tandemdiabetes/sugarmate-api-react-client"
import { LiquidUnit } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCalculationsContext } from "../CalculationsContext"
import type { TileProps } from "./TileProps"
import { TileTimeSpan } from "./TileTimeSpan"
import { TileTitle } from "./TileTitle"
import { TileUnit } from "./TileUnit"
import { TileValue } from "./TileValue"
import { usePolyglot } from "src/contexts"
import { liquidMicrolitersToUnit } from "src/utils"

export function LiquidTotal(props: TileProps<LiquidTotalInsight>) {
  const {
    insightKey,
    range,
  } = props

  const polyglot = usePolyglot()

  const { liquidCalculations } = useCalculationsContext()
  const { totalMicroliters } = liquidCalculations[range] || {}
  const value = totalMicroliters === undefined ?
    NaN :
    liquidMicrolitersToUnit(
      totalMicroliters,
      LiquidUnit.Milliliters,
    )

  const unit = polyglot.t(
    "unit.ml_unit",
    isNaN(value) ? 0 : value,
  )

  return (
    <>
      <TileTitle insightKey={insightKey} />
      <TileTimeSpan
        id={`${insightKey}-time-range`}
        range={range}
      />
      <TileValue id={`${insightKey}-value`}>
        {isNaN(value) ? "--" : value.toLocaleString(polyglot.locale())}
      </TileValue>
      <TileUnit id={`${insightKey}-unit`}>
        {unit}
      </TileUnit>
    </>
  )
}
